/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { setOrderSummaryRemappingSalesforceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const OrderSummaryRemappingABTest = ({ pageType }) => {
    const dispatchAction = useDispatch();
    const orderSummaryRemappingSaleForceABTest = useSelector((state) => state?.mfeCheckout?.app?.abTest?.orderSummaryRemapping || {});

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'All-Checkout-Order Summary Remapping-v1',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
    });

    const userGroup = data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup;
    const existingUserGroup = orderSummaryRemappingSaleForceABTest?.campaign?.campaignResponses?.[0]?.userGroup;

    useEffect(() => {
        if (userGroup && userGroup !== existingUserGroup) {
            dispatchAction(setOrderSummaryRemappingSalesforceABTest(data?.contentSF));
            dispatchAction(trackEvent({
                eventCategory: 'Experiment',
                eventAction: 'Order Summary Remapping',
                eventLabel: userGroup === 'Default' ? 'Variant' : 'Control',
                feature_category: 'Experiment',
                feature_element: 'Order Summary Remapping',
                feature_detail: userGroup === 'Default' ? 'Variant' : 'Control',
            }));
        }
    }, [existingUserGroup, userGroup, data?.contentSF]);

    if ((loading) || (!loading && !data && !error)) {
        return <></>;
    }

    if (error) {
        mbpLogger.logError({
            function: 'OrderSummaryRemappingABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Order Summary Remapping AB test returned an error',
            jsError: error,
        });
    }

    return <></>;
};

OrderSummaryRemappingABTest.propTypes = {
    pageType: string.isRequired,
};

export default OrderSummaryRemappingABTest;
